"use strict";
var appn;
(function (appn) {
    var tasks;
    (function (tasks) {
        function init(firstToClaimGuid, allToCompleteGuid, setUsersList) {
            $('.task-isAllDay').change(function () {
                if (this.checked) {
                    $('.task-startByCompleteBy-group').hide();
                    $('.task-allDayDate-group').show();
                    return;
                }
                $('.task-startByCompleteBy-group').show();
                $('.task-allDayDate-group').hide();
            });
            disableReassign($('.task-appUserId'), allToCompleteGuid);
            $('.task-appUserId').on('change', function (e) {
                disableReassign($(this), allToCompleteGuid);
            });
            $('.task-canReassign').change(function (e) {
                if ($(this).prop('checked'))
                    $('.task-reassignType').show();
                else
                    $('.task-reassignType').hide();
            });
            $('.task-canReassign').trigger('change');
            const $selectedTargetUsersOption = $('#Task_TargetUserType,#Template_Task_TargetUserType');
            const $formGroupTargetGroup = $('.form-control-AssignToGroup');
            const $formGroupTargetUsers = $('.form-control-AssignToUsers');
            const $assignToUserControlsCol = $('.assignToUserControlsCol');
            const $assignToUser = $('.task-appUserId');
            const hideFirstToClaimUi = function () {
                $assignToUserControlsCol.removeClass('col-md-8').addClass('col-md-4');
                $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').hide();
                $assignToUserControlsCol.find('.input-group-hook').removeClass('input-group');
                $formGroupTargetUsers.hide();
                $formGroupTargetGroup.hide();
                $('.targetedUserCountMessage').hide();
            };
            const showFirstToClaimUi = function () {
                $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
                $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
                $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
                toggleTargetGroup();
                toggleTargetUsers();
                $('.targetedUserCountMessage').show();
            };
            $assignToUser.on('change', function (e) {
                const selectedTz = $(this).find(':selected').data('appn-tz');
                if (selectedTz)
                    $('.task-timezone').val(selectedTz);
                if ($(this).val() === firstToClaimGuid || $(this).val() === allToCompleteGuid)
                    showFirstToClaimUi();
                else
                    hideFirstToClaimUi();
            });
            const toggleTargetGroup = function () {
                if (($assignToUser.val() === firstToClaimGuid || $assignToUser.val() === allToCompleteGuid) &&
                    $selectedTargetUsersOption.val() === 'Group') {
                    $formGroupTargetUsers.hide();
                    $formGroupTargetGroup.show();
                    $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
                    $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
                    $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
                }
            };
            const toggleTargetUsers = function () {
                if (($assignToUser.val() === firstToClaimGuid || $assignToUser.val() === allToCompleteGuid) &&
                    $selectedTargetUsersOption.val() === 'Users') {
                    $formGroupTargetGroup.hide();
                    $formGroupTargetUsers.show();
                    $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
                    $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
                    $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
                }
            };
            $selectedTargetUsersOption.change(function (e) {
                toggleTargetGroup();
                toggleTargetUsers();
            });
            toggleTargetGroup();
            toggleTargetUsers();
            if (setUsersList) {
                const $restrictToGroup = $('#Task_RestrictToGroup,#Template_Task_RestrictToGroup');
                $restrictToGroup.change(function () {
                    tasks.filterAssignedToUsersList($(this));
                    tasks.filterTargetGroupList($(this));
                    tasks.filterTargetUsersList($(this));
                    appn.select.init();
                });
                tasks.filterAssignedToUsersList($restrictToGroup);
                tasks.filterTargetGroupList($restrictToGroup);
                tasks.filterTargetUsersList($restrictToGroup);
                appn.select.init();
            }
            appn.dialog.showBillUpgradeOnClick(function () {
                $('.task-appUserId').val(appn.emptyString).change();
            });
        }
        tasks.init = init;
        function disableReassign(element, allToCompleteGuid) {
            if ($(element).val() === allToCompleteGuid) {
                $('.canReassign').hide();
                appn.ui.disableElement($('.task-canReassign'));
                $('.task-canReassign').prop('checked', false);
                return;
            }
            $('.canReassign').show();
            appn.ui.enableElement($('.task-canReassign'));
        }
        function initRecurring() {
            $('.taskRecurring-isRecurringTask').change(function () {
                if (this.checked) {
                    $('.startby-form-group').hide();
                    $('.completeby-form-group').hide();
                    $('#editRecurringConfigBtn').show();
                    $('#recurringTaskDialog').modal('show');
                    return;
                }
                $('.startby-form-group').show();
                $('.completeby-form-group').show();
                $('#editRecurringConfigBtn').hide();
            });
            $('#editRecurringConfigBtn').off().on('click', function (e) {
                e.preventDefault();
                $('#recurringTaskDialog').modal('show');
            });
            const toggleTaskRecurringType = function (taskRecurringType) {
                switch (taskRecurringType) {
                    case 'Daily': {
                        $('.repeat-every').text('days');
                        $('.recurring-weekly-group').hide();
                        break;
                    }
                    case 'Weekly': {
                        $('.repeat-every').text('weeks');
                        $('.recurring-weekly-group').show();
                        break;
                    }
                    case 'Monthly': {
                        $('.repeat-every').text('months');
                        $('.recurring-weekly-group').hide();
                        break;
                    }
                }
            };
            toggleTaskRecurringType($('.taskRecurring-taskRecurringType').find(':selected').val());
            $('.taskRecurring-taskRecurringType').change(function () {
                toggleTaskRecurringType($(this).val());
            });
            const toggleTaskRecurringEndsType = function (taskRecurringEndsType) {
                switch (taskRecurringEndsType) {
                    case 'Never': {
                        $('.occurrences-type').hide();
                        $('.specificdate-type').hide();
                        break;
                    }
                    case 'After': {
                        $('.occurrences-type').show();
                        $('.specificdate-type').hide();
                        break;
                    }
                    case 'On': {
                        $('.occurrences-type').hide();
                        $('.specificdate-type').show();
                        break;
                    }
                }
            };
            toggleTaskRecurringEndsType($('.taskRecurring-ends').find(':selected').val());
            $('.taskRecurring-ends').change(function () {
                toggleTaskRecurringEndsType(this.value);
            });
            const toggleIsAllDayEvent = function (isAllDayEvent) {
                if (isAllDayEvent) {
                    $('.start-by-time').hide();
                    $('.complete-by-time').hide();
                }
                else {
                    $('.start-by-time').show();
                    $('.complete-by-time').show();
                }
            };
            toggleIsAllDayEvent($('.taskRecurring-isAllDay').is(':checked'));
            $('.taskRecurring-isAllDay').change(function () {
                toggleIsAllDayEvent(this.checked);
            });
        }
        tasks.initRecurring = initRecurring;
        let _map;
        let _currentLatLon;
        let _currentText;
        let _latLonUser;
        let _marker;
        let _taskAddressSelectors;
        let _canSave;
        function initAddressMap(taskAddressSelectors, latLonUser, canSave = true) {
            _latLonUser = latLonUser;
            _taskAddressSelectors = taskAddressSelectors;
            _canSave = canSave;
            initmap();
            const locatebtn = $('#locatebtn');
            const completeAtText = $('#' + _taskAddressSelectors.completeAtText);
            appn.ui.enableDisableIfPopulated(completeAtText, locatebtn);
            locatebtn.click(function (event) {
                event.preventDefault();
                if (appn.ui.isElementDisabled($(this)))
                    return;
                findLocation();
            });
        }
        tasks.initAddressMap = initAddressMap;
        function initmap() {
            _map = appn.ui.mapInit('map', 0, 0, 11, false);
            const savedLat = $('#' + _taskAddressSelectors.completeAtLat).val();
            const savedLon = $('#' + _taskAddressSelectors.completeAtLon).val();
            const userLatLonBits = _latLonUser.split(',');
            const userLat = userLatLonBits[0];
            const userLon = userLatLonBits[1];
            if (savedLat !== '0') {
                _currentLatLon = new L.LatLng(savedLat, savedLon);
                initMarker();
                _map.setView(_currentLatLon, 15);
            }
            else {
                _currentLatLon = new L.LatLng(userLat, userLon);
                initMarker();
                _map.setView(_currentLatLon, 6);
                _map.on('locationfound', function (event) {
                    _currentLatLon = event.latlng;
                    initMarker();
                    _map.setView(_currentLatLon, 11);
                });
                _map.locate({ timeout: 5000 });
            }
        }
        function initMarker() {
            if (_canSave) {
                _marker = new L.Marker(_currentLatLon, { draggable: true });
                _marker.on('dragend', markerDragged);
            }
            else
                _marker = new L.Marker(_currentLatLon, { draggable: false });
            const icon = L.divIcon({
                html: '<div class="appn-mapPin"></div>' +
                    '<div class="appn-mapShadow"></div>'
            });
            _marker.setIcon(icon);
            _map.addLayer(_marker);
        }
        function markerDragged(event) {
            setCurrent(event.target.getLatLng(), $('#' + _taskAddressSelectors.completeAtLot).val() + ', ' + $('#' + _taskAddressSelectors.completeAtText).val());
            setMarker(Math.max(_map.getZoom(), 10));
            $('#searchResults').html('');
        }
        function setCurrent(latlng, text) {
            _currentLatLon = latlng;
            $('#' + _taskAddressSelectors.completeAtLat).val(_currentLatLon.lat);
            $('#' + _taskAddressSelectors.completeAtLon).val(_currentLatLon.lng);
            if (text.length > 3)
                _currentText = text;
            else
                _currentText = T('Unknown street address');
        }
        function setMarker(zoomlevel) {
            if (_marker === undefined)
                initMarker();
            _marker.unbindPopup();
            if (_currentText.length > 1) {
                const popupText = `<div class="appnMapPopup"><h5>${_currentText}</h5><span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${_currentLatLon.lat} ${_currentLatLon.lng}</span></div>`;
                const popup = _marker.bindPopup(popupText);
                popup.openPopup();
            }
            _marker.setLatLng(_currentLatLon);
            if (zoomlevel !== undefined)
                _map.setView(_currentLatLon, zoomlevel);
            else
                _map.setView(_currentLatLon, _map.getZoom());
        }
        function findLocation() {
            const lastResult = [];
            let locateText = $('#' + _taskAddressSelectors.completeAtLot).val() + ' ' + $('#' + _taskAddressSelectors.completeAtText).val() + ' ' + $('#' + _taskAddressSelectors.completeAtCountry).val();
            locateText = locateText.replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/, /g, '+').replace(/,/g, '+').replace(/ /g, '+');
            if (!locateText)
                return;
            $('#searchResults').html('<i>' + T('Searching...') + '</i>');
            appn.services.findLocationFromAddress(locateText, function (data) {
                let html = '<ul class="list-unstyled mt-3">';
                if (appn.utils.hasValue(data)) {
                    data.forEach((geoCodeLocation, index, results) => {
                        lastResult[index] = { location: geoCodeLocation, latlng: new L.LatLng(geoCodeLocation.Lat, geoCodeLocation.Lon) };
                        html += `<li>
                                <input class="mt-0" value="${index}" name="result" id="result${index}" type="radio"></input>
                                <label style="cursor:pointer" class="pl-8" for="result${index}"><i> ${geoCodeLocation.DisplayName}</i></label>
                            </li>`;
                    });
                    html += '</ul>';
                }
                else
                    html = T('No results found');
                $('#searchResults').html(html);
                $('input:radio').each(function () {
                    $(this).click(function () {
                        const current = $(this).val();
                        if (appn.utils.hasValue(lastResult[current].location.Address.HouseNumber)) {
                            $('#' + _taskAddressSelectors.completeAtText).val(lastResult[current].location.DisplayName.replace(lastResult[current].location.Address.HouseNumber + ', ', ''));
                            $('#' + _taskAddressSelectors.completeAtLot).val(lastResult[current].location.Address.HouseNumber);
                        }
                        else {
                            $('#' + _taskAddressSelectors.completeAtText).val(lastResult[current].location.DisplayName);
                            $('#' + _taskAddressSelectors.completeAtLot).val('');
                        }
                        setCurrent(lastResult[current].latlng, lastResult[current].location.DisplayName);
                        setMarker(16);
                    });
                });
            });
        }
        function filterAssignedToUsersList($restrictToGroup) {
            const $assignToUser = $('.task-appUserId');
            const $options = $assignToUser.find('option');
            appn.ui.disableElement($assignToUser.find('option[data-appn-tz]')).hide();
            let rtg = $restrictToGroup.val();
            if (!rtg || rtg === appn.emptyGuid) {
                appn.ui.enableElement($assignToUser.find('option')).show();
                return;
            }
            rtg = rtg.replace(/-/g, appn.emptyString);
            for (let i = 0; i < $options.length; i++) {
                const groups = $($options[i]).data('appn-groups');
                if (!groups)
                    continue;
                if (groups.indexOf(rtg) >= 0)
                    appn.ui.enableElement($($options[i])).show();
            }
            const $selectedAssignedTo = $assignToUser.find('option:selected');
            if (appn.ui.isElementDisabled($selectedAssignedTo)) {
                if ($assignToUser.find('option[value="' + appn.emptyGuid + '"]').length)
                    $assignToUser.val(appn.emptyGuid);
                else
                    $assignToUser.val(appn.emptyString);
                appn.toast.notify(appn.toast.Type.warning, T(`The Assigned To User was reset because he/she does not belong to the restricted group <b>'{0}'</b>`, $restrictToGroup.find('option:selected').text()));
            }
        }
        tasks.filterAssignedToUsersList = filterAssignedToUsersList;
        function filterTargetGroupList($restrictToGroup) {
            const $targetGroup = $('#Task_TargetGroup,#Template_Task_TargetGroup');
            if (!$restrictToGroup.val() || $restrictToGroup.val() === appn.emptyGuid) {
                appn.ui.enableElement($targetGroup.find('option')).show();
                return;
            }
            appn.ui.disableElement($targetGroup.find('option')).hide();
            appn.ui.enableElement($targetGroup.find('option[value=""]')).show();
            const restrictToGroupId = $restrictToGroup.val();
            appn.ui.enableElement($targetGroup.find('option[value="' + restrictToGroupId + '"]')).show();
            const $selectedTargetGroup = $targetGroup.find('option:selected');
            if (appn.ui.isElementDisabled($selectedTargetGroup)) {
                $targetGroup.val(appn.emptyString);
                appn.toast.notify(appn.toast.Type.warning, T(`The Assigned To User Group was reset because Restrict Group <b>'{0}'</b> was selected.`, $restrictToGroup.find('option:selected').text()));
            }
        }
        tasks.filterTargetGroupList = filterTargetGroupList;
        function filterTargetUsersList($restrictToGroup) {
            const $targetUsersHidden = $('#Task_TargetUsers,#Template_Task_TargetUsers');
            const $targetUsersSelected = $('#bootstrap-duallistbox-selected-list_Task\\.TargetUsers,#bootstrap-duallistbox-selected-list_Template\\.Task\\.TargetUsers');
            const $targetUsersNonSelected = $('#bootstrap-duallistbox-nonselected-list_Task\\.TargetUsers, #bootstrap-duallistbox-nonselected-list_Template\\.Task\\.TargetUsers');
            const $optionsHidden = $targetUsersHidden.find('option');
            const $optionsSelected = $targetUsersSelected.find('option');
            const $optionsNonSelected = $targetUsersNonSelected.find('option');
            appn.ui.disableElement($optionsHidden).hide();
            appn.ui.disableElement($optionsSelected).hide();
            appn.ui.disableElement($optionsNonSelected).hide();
            let rtg = $restrictToGroup.val();
            if (!rtg || rtg === appn.emptyGuid) {
                appn.ui.enableElement($targetUsersHidden.find('option')).show();
                appn.ui.enableElement($targetUsersSelected.find('option')).show();
                appn.ui.enableElement($targetUsersNonSelected.find('option')).show();
                return;
            }
            rtg = rtg.replace(/-/g, appn.emptyString);
            for (let i = 0; i < $optionsHidden.length; i++) {
                const groups = $($optionsHidden[i]).data('appn-groups');
                if (!groups)
                    continue;
                if (groups.indexOf(rtg) >= 0)
                    appn.ui.enableElement($($optionsHidden[i])).show();
            }
            for (let i1 = 0; i1 < $optionsSelected.length; i1++) {
                const groups1 = $($optionsSelected[i1]).data('appn-groups');
                if (!groups1)
                    continue;
                if (groups1.indexOf(rtg) >= 0)
                    appn.ui.enableElement($($optionsSelected[i1])).show();
            }
            for (let i2 = 0; i2 < $optionsNonSelected.length; i2++) {
                const groups2 = $($optionsNonSelected[i2]).data('appn-groups');
                if (!groups2)
                    continue;
                if (groups2.indexOf(rtg) >= 0)
                    appn.ui.enableElement($($optionsNonSelected[i2])).show();
            }
            const $selectedAssignedTo = $targetUsersHidden.find('option:selected');
            if (appn.ui.isElementDisabled($selectedAssignedTo)) {
                if ($targetUsersHidden.find('option[value="' + appn.emptyGuid + '"]').length)
                    $targetUsersHidden.val(appn.emptyGuid);
                else
                    $targetUsersHidden.val(appn.emptyString);
                appn.toast.notify(appn.toast.Type.warning, T(`One or more of the selected Assigned To Users are disabled because they do not belong to the restricted group <b>'{0}'</b>`, $restrictToGroup.find('option:selected').text()));
            }
        }
        tasks.filterTargetUsersList = filterTargetUsersList;
        function showAddNewDialog(isTaskRecurringContext, overideTime, startByUtc, completeByUtc, isAllDay, returnAction) {
            let url = appn.urls.taskTemplates.wizard1;
            if (isTaskRecurringContext)
                url += '?isTaskRecurringContext=true';
            if (returnAction)
                url += `?returnAction=${returnAction}`;
            if (overideTime) {
                if (!isTaskRecurringContext)
                    url += '?';
                else
                    url += '&';
                url += `startByUtc=${encodeURIComponent(startByUtc ? startByUtc : appn.emptyString)}
                &completeByUtc=${encodeURIComponent(completeByUtc ? completeByUtc : appn.emptyString)}&isAllDay=${isAllDay ? isAllDay : false}`;
            }
            const selectedTemplateId = appn.taskTemplateFilter.getValue();
            if (selectedTemplateId) {
                if (url.indexOf('?') === -1)
                    url += '?';
                else
                    url += '&';
                url += `Wizard1TemplateId=${encodeURIComponent(selectedTemplateId)}`;
            }
            appn.iframe.openModal({ url: url })
                .then(function ($modal) {
                $modal.on('hidden.bs.modal', function () {
                    appn.location.reloadCurrentPage();
                });
            });
        }
        tasks.showAddNewDialog = showAddNewDialog;
        let TaskStatus;
        (function (TaskStatus) {
            TaskStatus[TaskStatus["Draft"] = 0] = "Draft";
            TaskStatus[TaskStatus["Sent"] = 1] = "Sent";
            TaskStatus[TaskStatus["Accepted"] = 2] = "Accepted";
            TaskStatus[TaskStatus["Rejected"] = 3] = "Rejected";
            TaskStatus[TaskStatus["InProgress"] = 4] = "InProgress";
            TaskStatus[TaskStatus["Completed"] = 5] = "Completed";
        })(TaskStatus = tasks.TaskStatus || (tasks.TaskStatus = {}));
    })(tasks = appn.tasks || (appn.tasks = {}));
})(appn || (appn = {}));
